import styled from "styled-components";

export const ChartContainer = styled.span`
    path {
        transition: 2s ease-in;
    }

    text {
        fill: ${({theme}) => theme.colors.textColor};
        
        tspan {
            fill: ${({theme}) => theme.colors.textColor} !important;
        }
    }
`